// extracted by mini-css-extract-plugin
export default {"select":"ProfileSelector_select__4iHTd","profileInput":"ProfileSelector_profileInput__JdXBc"};